import { render, staticRenderFns } from "./AdvisorCoreExport.vue?vue&type=template&id=413dc040&"
import script from "./AdvisorCoreExport.vue?vue&type=script&lang=js&"
export * from "./AdvisorCoreExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports